import PropTypes from 'prop-types';
import { BannerProvider } from '@splunk/olly-common/GettingStartedBanner';
import { gettingStartedBannerContentDashboards } from './dashboardGSBContent';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../../common/theme/ThemeProvider';
import { AngularInjector } from '../../../common/AngularUtils';
import { useFeatureFlags } from '@splunk/olly-services/lib/services/FeatureFlag/FeatureFlagStoreProvider';

export default function DashboardBanner({ currentUser }) {
    const userAnalytics = AngularInjector.useInjectedClass('userAnalytics');
    const themeKey = useLegacyThemeServiceKey();
    const { featureFlags: magneticPageHeader } = useFeatureFlags();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <BannerProvider
                currentUser={currentUser}
                themeKey={themeKey}
                gettingStartedBannerContent={{
                    ...gettingStartedBannerContentDashboards,
                    showTopPadding: !magneticPageHeader,
                }}
                userAnalytics={userAnalytics}
                dismissedPillarApiName="sf_uiOnboardingBannerDismissedDashboards"
            />
        </ThemeProvider>
    );
}

DashboardBanner.propTypes = {
    currentUser: PropTypes.object,
};
